// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58f6d107","835":"edfaa25d","962":"42d2869a"}[chunkId] + ".chunk.js";
};